module.exports = "/assets/data/2b139ed56c422fe87c4449cba031dabe-OX18.data.json";